module.exports = __webpack_public_path__ + "img/yes.bc2b77e1.svg";